var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8419 9.12402L12.3326 15.3853L8.65389 11.1015H2.19922C5.27655 16.8854 12.8659 20.8252 12.8659 20.8252C12.8659 20.8252 20.4566 16.8854 23.5326 11.1015H17.1326L15.8419 9.12402Z",
    fill: "#6D7278"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6739 0.0239258C17.4074 0.0244463 16.1716 0.365897 15.1333 1.0022C14.0949 1.6385 13.304 2.53903 12.8672 3.58225C12.3651 2.3857 11.3995 1.38225 10.1393 0.747562C8.87918 0.11287 7.40479 -0.112622 5.97428 0.110561C4.54376 0.333744 3.24827 0.99138 2.3146 1.96834C1.38092 2.94531 0.868553 4.17935 0.867188 5.45443C0.873187 6.56821 1.08621 7.67367 1.49785 8.72725H9.42319L12.0459 11.7251L15.7499 5.23562L18.0779 8.72608H24.2379C24.6483 7.67429 24.8609 6.57086 24.8672 5.45912C24.8672 4.01761 24.2147 2.63515 23.0532 1.61586C21.8917 0.59656 20.3164 0.0239258 18.6739 0.0239258V0.0239258Z",
    fill: "#6D7278"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.99cc0921f4018c1ca36d8d1240ca5301.svg";
export { ForwardRef as ReactComponent };